var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4167 30.625L20.4167 24.5",
    stroke: "#B81212",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5833 30.625L28.5833 24.5",
    stroke: "#B81212",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 14.292H42.875H40.75C38.8644 14.292 37.9216 14.292 37.3358 14.8778C36.75 15.4636 36.75 16.4064 36.75 18.292V36.8337C36.75 38.7193 36.75 39.6621 36.1642 40.2479C35.5784 40.8337 34.6356 40.8337 32.75 40.8337H16.25C14.3644 40.8337 13.4216 40.8337 12.8358 40.2479C12.25 39.6621 12.25 38.7193 12.25 36.8337V18.292C12.25 16.4064 12.25 15.4636 11.6642 14.8778C11.0784 14.292 10.1356 14.292 8.25 14.292H6.125Z",
    stroke: "#B81212",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5557 6.88162C20.7884 6.66456 21.301 6.47275 22.0141 6.33595C22.7273 6.19915 23.601 6.125 24.4999 6.125C25.3988 6.125 26.2726 6.19915 26.9857 6.33595C27.6988 6.47275 28.2115 6.66456 28.4441 6.88162",
    stroke: "#B81212",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.2fdfbbfe013723f147641fd26985e1fa.svg";
export { ForwardRef as ReactComponent };